module.exports = __webpack_public_path__ + "static/media/sign-in-logo-yellow-september.1f860e3d.svg";